import React, { Fragment, useContext, useEffect, useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";

import AuthContext from "../../context/AuthContext";
import useObtenerUsuario from "../../utils/useObtenerUsuario";

import MPage from "../templates/mpage";
import AdminEtapa from "../components/adminetapa";
import AdminVotacionConfig from "../components/adminvotacionconfig";
import PropBox from "../components/propbox";
import AdminVotacion from "../components/adminvotacion";
import AdminVoto from "../components/adminvoto";
import Cargando from "../components/cargando";
import useTituloPagina from "../../utils/useTituloPagina";

const Consola = (props) => {
  const { loggedIn, guardarLoggedIn } = useContext(AuthContext);
  const [usuario, errorUsuario] = useObtenerUsuario(loggedIn);
  const [municipio, guardarMunicipio] = useState(undefined);
  const [propuestas, guardarPropuestas] = useState(undefined);
  const [filtro, guardarFiltro] = useState("pendiente");
  const [pFiltradas, guardarPFiltradas] = useState([]);
  const [error, guardarError] = useState(false);
  useTituloPagina("Consola de administración");

  //Se obtiene el municipio al que pertenece ese usuario y sus propuestas.
  useEffect(() => {
    if (usuario !== undefined) {
      const obtenerMunicipio = () => {
        axios
          .get(`/api/municipios/${usuario.municipioId}`)
          .then((res) => {
            guardarMunicipio(res.data.municipio);
          })
          .catch((error) => guardarError(true));
      };
      obtenerMunicipio();

      const obtenerPropuestas = () => {
        axios
          .get(`/api/propuestas/?municipioId=${usuario.municipioId}`)
          .then((res) => {
            guardarPropuestas(res.data.propuestas);
          })
          .catch((error) => guardarError(true));
      };
      obtenerPropuestas();
    }
    return () => {
      guardarMunicipio(undefined);
      guardarPropuestas(undefined);
    };
  }, [usuario]);

  //Se obtienen las propuestas segun el filtro.
  useEffect(() => {
    if (propuestas !== undefined) {
      guardarPFiltradas(propuestas.filter((prop) => prop.estado === filtro));
    }
  }, [propuestas, filtro]);

  //Logout de usuario
  const logout = async () => {
    await axios.get("/api/usuarios/logout");
    guardarLoggedIn(false);
    props.history.push("/login");
  };

  if (loggedIn === false) return <Redirect to="/login" />;
  if (error === true || errorUsuario === true) return <Redirect to="/" />;
  if (
    usuario === undefined ||
    municipio === undefined ||
    propuestas === undefined
  )
    return <Cargando />;

  return (
    <MPage municipio={municipio}>
      {/*LogOut*/}
      <div className="row">
        <div className="col-md-12 text-right">
          <button
            className="btn ppr-btn-rojo font-weight-bold btn-sm my-2"
            onClick={logout}
          >
            Desconectarse
          </button>
        </div>
      </div>
      {/*Titulo*/}
      <div className="row">
        <div className="col-md-12">
          <h1 className="ppr-titulo centrado h2">Consola Administración</h1>
        </div>
      </div>
      {/*Modulo Administración de etapa*/}
      {usuario.adminEtapa === true && <AdminEtapa municipio={municipio} />}

      {/*Configuración de las reglas de la votación pública. Va con el permiso
         de etapa porque es el que habilita la ruta que guarda el municipio.*/}
      {usuario.adminEtapa === true && (
        <AdminVotacionConfig municipio={municipio} />
      )}

      {/*Modulo Administración de votación*/}
      {usuario.adminVotacion === true && (
        <AdminVotacion municipio={municipio} />
      )}
      {/*Modulo Administración de un voto*/}
      {usuario.adminVoto === true && municipio.tipoVotacion === "privada" && (
        <AdminVoto municipio={municipio} />
      )}
      {/*Modulo Administración de propuestas*/}
      {usuario.adminPropuestas === true && (
        <Fragment>
          <div className="row">
            <div className="col-md-12">
              <h2 className="ppr-titulo centrado my-2 h4">
                Administrar Propuestas
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8 centrar-col">
              <p>
                Utilice el selector para encontrar las distintas propuestas, las
                mismas se encuentran agrupadas en las siguientes categorías:
                Propuestas pendientes, propuestas aceptadas para votación,
                propuestas archivadas, propuestas seleccionadas para ejecución.
              </p>
              <p>
                Haciendo click en el botón <b>"Administrar"</b> de la propuesta
                se accede a la página de edición de la misma.
              </p>
              <p>
                Haciendo click en <b>"(Vista para Impresión)"</b> se accede a la
                una página simplificada para imprimir la propuesta presionando
                las teclas "ctrl" + "p".
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 p-4 centrar-col">
              <select
                onChange={(e) => {
                  guardarFiltro(e.target.value);
                }}
                className="custom-select"
              >
                <option value="pendiente">Propuestas Pendientes</option>
                <option value="aceptada">Propuestas Aceptadas</option>
                <option value="seleccionada">Propuestas Seleccionadas</option>
                <option value="archivada">Propuestas Archivadas</option>
              </select>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {pFiltradas.length === 0 ? (
                <p className="text-center text-muted my-4">
                  No hay propuestas en esta categoría.
                </p>
              ) : (
                pFiltradas.map((propuesta) => (
                  <div key={propuesta._id}>
                    <PropBox propuesta={propuesta} />
                  </div>
                ))
              )}
            </div>
          </div>
        </Fragment>
      )}
    </MPage>
  );
};

export default withRouter(Consola);
